import { clientLogger } from '../../../lib/logger';

export const getExtraInfoContent = extraItem => {
  try {
    return Object.values(JSON.parse(extraItem));
  } catch (error) {
    clientLogger.warn(
      'Error while parsing extra info for Details Photo Section',
      error
    );
    return [];
  }
};

export const getDeveloperLinkContent = extraInfo => {
  try {
    if (Array.isArray(extraInfo) && extraInfo.length) {
      const developerLink = extraInfo.filter(e =>
        e.hasOwnProperty('linkText' && 'linkUrl')
      )[0];
      return developerLink;
    }
    clientLogger.warn('Developer link content not available');
    return null;
  } catch (error) {
    clientLogger.warn(
      'Error parsing developer link for Details Photo Section',
      error
    );
    return null;
  }
};

export const getImageButtonValues = imageButton => {
  try {
    const imgButtonObj = imageButton ? JSON.parse(imageButton) : {};
    return Object.values(imgButtonObj);
  } catch (error) {
    clientLogger.warn(
      'Error parsing image button content for Details Photo Section',
      error
    );
    return [];
  }
};
